/**
 * Échelle typographique de l'interface.
 *
 * <p>Ce sont les tailles de la maquette V288, référence visuelle du client :
 * un écran dense, lu sur téléphone comme dans la fenêtre centrée du bureau.
 * Les documents A4 (`features/documents`, fiches de paie, contrats) ne sont
 * pas concernés : leurs tailles sont celles de l'impression.
 */
export const FS = {
  /** Sur-titres en capitales espacées et libellés de champ. */
  micro: 9,
  /** Textes secondaires, petits boutons, onglets. */
  xs: 9.5,
  sm: 11,
  md: 12,
  lg: 13,
  xl: 16,
};
